export const Handlebars: any = require("handlebars-template-loader/runtime");
interface HandlebarsTemplate {
  (opts: any): string;
}

export const validateAddressSuggestionTemplate: HandlebarsTemplate = require("./views/validateAddressSuggestion.hbs");
